<template>
    <div class="shop-container">
        <div class="nav">
          <router-link to="home">{{$t('home')}}</router-link>
          <span>></span>
          <router-link :to="{path: '/video' }">{{$t('video')}}{{$t('home')}}</router-link>
          <span>></span>
          <router-link v-if="info.course_type" :to="{name: 'videoclassify', query: {id: info.course_type.id,pid: info.course_type.pid} }">{{info.course_type.type_name}}</router-link>
          <span>></span>
          <span>{{info.title}}</span>
        </div>
        <div class="article-left">
          <div class="video-wrap">
            <div class="player-wrap" v-if="info.id">
              <div class="video-place" :class="{white: !userToken}" v-if="!userToken || !info.video_id">
                <img class="logo" v-if="userToken" src="@/assets/images/arrow/logo.png" alt="">
                <img class="arrow" v-if="userToken" src="@/assets/images/arrow/arrow.png" alt="">
                <div class="btn-wrap" >
                  <el-button class="btn-item btn-01" @click="buy" v-if="userToken">
                    {{$t('buy')}} {{$t('currencySymbol')}}{{info.price}} 
                  </el-button>
                  
                  <router-link to="/login" class="btn-item btn-01" v-else style="height: 40px; line-height: 40px">
                    {{$t('videoLoginTips')}}
                  </router-link>
                  
                </div>
              </div>
              <template  v-else>
                <!-- <video class="video-player"  :src="playerOptions.sources[0].src"  controls="controls" ></video> -->
                <!-- <vue-aliplayer-v2 class="video-player"    :source="player.options.source" ref="video"
                @playing="play"
                :options="player.options" /> -->
                <video-player @play="play"  v-if="$i18n.locale == 'zh'" class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                ></video-player>
                 <youtube v-else video-id="CJ0xx9hJua4" ref="youtube" @playing="play"></youtube>
              </template>
              
            </div>
            

            <div class="tabs">
              <div class="item active">{{$t('video')}}{{$t('introduction')}}</div>
            </div>
            <div class="brief">{{info.brief}}</div>
            
          </div>

          <!-- 相关教程 -->
            <div class="other-video">
              <el-tabs v-model="tabs">
                <el-tab-pane :label="$t('tutorials')" name="1">
                  <div class="video-list">
                    <div class="video-list-item">
                       <div @click="reloadDetail(item.id)" class="link" v-for="item in relevantList" :key="item.id">
                            <div class="img-wrap" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}">
                              <!-- <img :src="item.cover" alt=""> -->
                              <div class="palynums"> <span></span> {{item.pv}}</div>
                            </div>
                            <h3 class="title">{{item.title}}</h3>
                        </div>
                    </div>
                  </div>
                </el-tab-pane>
                <!-- 最近更新 -->
                <el-tab-pane :label="$t('recentUpdates')" name="2">
                  <div class="video-list">
                    <div class="video-list-item">
                        <div class="link"  @click="reloadDetail(item.id)" v-for="item in timeList" :key="item.id">
                            <div class="img-wrap" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}">
                              <!-- <img :src="item.cover" alt=""> -->
                              <div class="palynums"> <span></span> {{item.pv}}</div>
                            </div>
                            <h3 class="title">{{item.title}}</h3>
                        </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

          <!-- 评论 -->

          <div class="comment-list">

            <div class="none-comment">{{$t('new')}}{{$t("comment")}}</div>
            <div class="comment-list-item"  v-for="item in commentlist" :key="item.id">
              <div class="reply_list_img">
                <img :src="item.user.avatar" alt="">
              </div>
              <div class="reply_list_con">
                <div class="auth_msg clearfix"><i>{{item.user.nickname}}</i> {{$t('replyTime')}}{{item.ctime}}</div>
                <div class="reply_txt">{{item.content}}</div>
              </div>
            </div>

          </div>

          <div class="replay-action">
            <div class="comment-list-item" >
              <div class="reply_list_img">
                <img src="http://bpic.588ku.com/element_origin_min_pic/18/06/10/d52f4a4979784dabb9583c1e9d7212d0.jpg" alt="">
              </div>
              <div class="reply_list_con">
                <el-input  type="textarea" rows="6" :placeholder="$t('pleaseEnterContent')"  v-model="content">  </el-input>
                <el-button @click="commentAction">{{$t('reply')}}</el-button>
              </div>
            </div>
          </div>


        </div>
        <!-- 热门视频 -->
        <div class="article-right">
            <div class="academy box">
                <h4>
                    <strong>{{$t('hot')}}{{$t('video')}}</strong>
                    <router-link to="/video" class="link"><!-- {{$t('more')}}> --></router-link>
                </h4>
                <ul>
                  <template v-for="(item, index) in hot">
                     <li v-if="index < 6" :key="item.id"> 
                        <div @click="reloadDetail(item.id)"  class="link">
                          <div class="palynums"> <span></span> {{item.pv || '0'}} </div>
                            <!-- <img :src="item.cover" alt=""> -->
                            <div class="img-bg" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
                            <div class="title">{{item.title}}</div>
                        </div>
                    </li>
                  </template>
                </ul>
            </div>
        </div>
        <div class="dia-pay-wrap">
        <el-dialog :visible="dialog" >
          <div class="dia-top-pic-wrap">
            <div class="info">
              <img  v-if="userInfo.avatar" :src="userInfo.avatar "  class="avatar" alt="">
              <img class="avatar"   v-else src="../../assets/images/avatar-default.png"  alt="">
              <div class="user">
                <div class="user-name">{{userInfo.username || userInfo.mobile || ''}}</div>
                <div class="desc" v-if="userInfo && userInfo.cycle && userInfo.cycle.end_time">{{userInfo.cycle.end_time}}</div>
                <div class="desc" v-else>您还不是会员，开通福利多多</div>
              </div>
              <img class="close-dig" src="../../assets/images/video/close-b.png" alt="" @click="dialog = false">
            </div>
          </div>
          <div class="dia-wrap"> 
 
            <div class="card-wrap">
              <div class="card-item" v-for="(item, index) in cardlist" :key="item.id" @click="selectPic(item, index)">
                <img class="pic"  :src="cardCurrent == item.id ? require('@/assets/images/arrow/card-h.png') : require('@/assets/images/arrow/card.png')" alt="">
                <div class="title">{{item.name}}</div>
                <div class="price">￥{{item.price}}</div>
              </div>
            </div>

            <div class="pay-wrap">
              <div class="title">选择支付</div>
              <div class="pay-list">
                <div class="pay-item">
                  <el-radio-group v-model="payType">
                    <el-radio :label="item.code" v-for="(item,index) in payments" :key="index">
                      <span class="pay-type" :class="{'active':payType==item.code}">
                        <i class="icon iconfont iconxianxiamendian" v-if="item.code=='offline'"></i>
                        <i class="icon iconfont iconyuezhifu" v-else-if="item.code=='balancepay'"></i>
                        <i class="icon iconfont iconzhifubao" v-else-if="item.code=='alipay'"></i>
                        <i class="icon iconfont iconweixinzhifu" v-else-if="item.code=='wechatpay'"></i>
                        {{item.name}}
                      </span>
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="pay-action">
                    <span class="price">{{$t('currencySymbol')}}{{cardlist[cardIndex].price}}</span>  
                    <el-button :loading="btnLoading" type="" @click="buyVideo">{{$t('toPay')}}</el-button>
                  </div>
              </div>
            </div>

            <div> 
              <router-link to="/">《会员服务协议》</router-link>
            </div>
          </div>
        </el-dialog>
        </div>


        <template v-if="dialogPaymentShow">
          <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
        </template>

    </div>
</template>

<script>
import SwiperSmall from '@/components/common/SwiperSmall'
import Payment from "@/components/payment.vue";
import { locationHost } from "@/config/env.js";

export default {
    inject:['reload'],
    components: {
        SwiperSmall,
        Payment
    },
    data() {
        return {
            dialogPaymentShow: false,
            payType: "alipay",
            payments: [],
            dialog: false,
            tabs: '1', // tabs菜单切换
            activeName: 'jxdd',
            activeNameTj: 'tj',
            player: {
              options: {
                source: '',
                width: '100%',
                height: "100%",
                cover: '',
                autoplay: false,
                // preload: false,
                // diagnosisButtonVisible: false,
                definition: ['FD', 'LD', 'SD'],
                isLive: false,
                controlBarVisibility: "click"
              },
              show: false,
            },
            // hot:[
            //     {name: '国办赛事', id: '1', link: '/'},
            //     {name: '行业新闻', id: '1', link: '/'},
            //     {name: '技术动态', id: '1', link: '/'},
            //     {name: '行业政策', id: '1', link: '/'},
            //     {name: '射礼团体', id: '1', link: '/'},
            //     {name: '产品动态', id: '1', link: '/'},
            //     {name: '射箭体校', id: '1', link: '/'},
            //     {name: '商业联赛', id: '1', link: '/'},
            // ],
            sliceNum: 2,
            playerOptions : {
              playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
              autoplay: false, //如果true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 导致视频一结束就重新开始。
              preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: 'zh-CN',
              aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [{
                // type: "application/x-mpegURL",
                // video/mp4
                src: ''//url地址          
                // src: "" //url地址
              }],
              poster: "", //你的封面地址
              // notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
              }
            },
            cardlist: [
              {name: '本视频', id:1, price: 10, desc: ''},
              // {name: '月卡',id:2, price: 30, desc: ''},
              // {name: '季卡',id:3, price: 50, desc: ''},
              // {name: '年卡', id:4,price: 100, desc: ''},
            ],
            cardCurrent: 1,
            cardIndex: 0,
            id: '', // 视频Id
            info: {}, // 视频详情
            content: '', // 回复框
            commentlist: [], // 评论列表
            hot: [],
            form: {
              page: 1,
              limit: 10,
              where: {
                is_hot: 1
              }
            },
            commentForm:{
              page:1,
              limit: 10
            },
            acc: 0,
            relevantList: [ ], // 相关教程
            userInfo: {},
            timeList: [], // 最近更新
            canPlay: false,
            code_url: '',
            btnLoading: false,
            userToken: ''
        }
    },
    created() {
      this.id = this.$route.params.videoId
      this.getPaymentType();
      this.init()
      this.comment()
      this.list('hot')
      this.byTime()
      this.relevant()
      this.card()

      if(localStorage.getItem('userInfo')) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))  || {}
      } 

      if(localStorage.getItem('userToken')) {
        this.userToken = JSON.parse(localStorage.getItem('userToken'))  || ''
      }
    },
    mounted() {
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1000);
        let data = {
          course_id: this.id
        } 
        if(localStorage.getItem('userToken')) {
          data.token = localStorage.getItem('userToken')
        }
         this.$api.coursesetlog(data)
    },
    methods:{
      // 清除定时器
      clearInterPay() {
        clearInterval(this.intervalPayStatus);
        this.dialogPaymentShow = false;
        this.btnLoading = false
      },
      // 校验视频权限
      check() {
        this.$api.coursecheckcourse({
          course_id: this.info.id
        }).then(res => {
          if(res.status) {
            this.canPlay = true
            // this.init()
          }
        })
      },
      // 选择卡片
      selectPic(val, index) {
        this.cardCurrent = val.id
        this.cardIndex = index
      },
      // 购买视频
      buyVideo(){
        // if()
        let data = {
            course_id: this.cardIndex == 0 ? this.info.id : this.cardCurrent,
            payment_type: this.cardIndex == 0 ? 1 : 2, // 1视频 2 视频卡
            payment_code: this.payType,
            source: '1'
        }
        this.$api.coursepay(data).then( res => {
          if(res.status) {
            this.createAction(res.data.order_id)
          }
        })
      },
      // 最近更新
      byTime() {
        let data = {
          page: 1,
          limit: 8,
          where: JSON.stringify({order: 'ctime desc'})
        }
        this.$api.courseGetlist(data).then(res => {
          if(res.status) {
            this.timeList = res.data.list
            // console.log('res', res)
          }
        })
      },
      // 创建视频订单
      createAction(ids) {
        this.btnLoading = true;
        let code = this.payType;
        if(code == 'wechatpay') {

          let data = {
            ids,
            payment_code: this.payType,
            payment_type: this.cardIndex == 0 ? 3 : 4, //  3=视频 4=视频卡
            params: {
              trade_type: "NATIVE"
            }
          }
          this.$api.pay(data).then(res => {
            if(res.status) {
              this.code_url = res.data.code_url;
              this.dialogPaymentShow = true
              this.getPaymentStatus(res.data.payment_id);
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else if (code == "alipay") {
          let data = {
            ids,
            payment_code: this.payType,
            payment_type: this.cardIndex == 0 ? 3 : 4, //  3=视频 4=视频卡
            params: {
              trade_type: "PC",
              return_url:
                locationHost+ "/#/cashier/" + ids
            }
          };

          this.$api.pay(data).then(res => {
            this.btnLoading = false;
            if (res.status) {
              this.standarPost(res.data.url, res.data.data);
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        } else if (code == "balancepay") {
          // 余额支付
          let data = {
            ids,
            payment_code: this.payType,
            payment_type: this.cardIndex == 0 ? 3 : 4, //  3=视频 4=视频卡
          };
          this.$api.pay(data).then(res => {
              this.btnLoading = false;
            if (res.status && res.msg == this.$t('paySucess')) {
              this.$msg(this.$t('paySucess'));
              // this.toPaySuccess();
              this.dialog = false
              this.init()
            } else {
              this.$msg(res.msg, "warning");
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        } else if (code == "offline") {
          this.$confirm(this.$t('paymentofflineTitle'), this.$t('offlineExplain'), {
            confirmButtonText: this.$t('orderDetail'),
            cancelButtonText: this.$t('next'),
            type: "info"
          })
            .then(() => {
              this.btnLoading = false;
              this.$router.replace({
                name: "orderDetail",
                params: { order_id: ids }
              });
            })
            .catch(() => {
              this.btnLoading = false;
              // this.$router.replace({ name: "home" });
            });
        } else if(code == 'paypal') {
          let data = {
            ids,
            payment_code: this.payType,
            payment_type: this.cardIndex == 0 ? 3 : 4, //  3=视频 4=视频卡
            params: {
              trade_type: "PC",
              return_url:
                locationHost+ "/#/cashier/" + ids
            }
          };
          this.$api.pay(data).then(res => {
              this.btnLoading = false;
            if (res.status && res.msg == this.$t('paySucess')) {
              this.$msg(this.$t('paySucess'));
              // this.toPaySuccess();
              window.open(res.data.url, '_blank')
              // this.init()
            } else {
              this.$msg(res.msg, "warning");
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        }
      },
      // 支付宝支付后
      standarPost(url, data) {
        let tempForm = document.createElement("form");
        tempForm.id = "aliPay";
        tempForm.methods = "post";
        tempForm.action = url;
        tempForm.target = "_self";
        let input = [];
        for (let k in data) {
          input[k] = document.createElement("input");
          input[k].type = "hidden";
          input[k].name = k;
          input[k].value = data[k];
          tempForm.appendChild(input[k]);
        }
        tempForm.addEventListener("submit", function() {}, false);
        document.body.appendChild(tempForm);
        tempForm.dispatchEvent(new Event("submit"));
        tempForm.submit();
        document.body.removeChild(tempForm);
      },
      getPaymentStatus(id) {
        let data = {
          payment_id: id
        };
        let that = this;
        this.intervalPayStatus = setInterval(function() {
          that.$api.paymentInfo(data).then(res => {
            if (res.status) {
              if (res.data.status == 2) {
                that.$msg(this.$t('paySucess'));
                that.dialogPaymentShow = false;
                that.dialog = false
                that.init()
              }
            }
          });
        }, 1000);
      },
      relevant() {
        this.$api.getrelevant({id: this.id}).then(res =>{
          if(res.status) {
            this.relevantList = res.data

            console.log('圣迹X10高级竞技反曲弓双边V座', res.data)
          }
        })
      },
      // 视频播放了
      play() {
        console.log(1)
        this.acc += 1
        // 第一次播放 计数
        if(this.acc == 1) {
          let data = {
            course_id: this.id,
            is_play: 1
          }
          if(localStorage.getItem('userToken')) {
            data.token = localStorage.getItem('userToken')
          }
          // 增加播放量
          this.$api.coursesetlog(data)
        }
      },
      reloadDetail(id) {
        this.$router.push({
          name: 'videodetail',
          params: {
            videoId: id
          }
        })
        this.reload()
      },

      initParams() {
          let copy = JSON.parse(JSON.stringify(this.form))
          copy.where = JSON.stringify(copy.where)
          return copy
      },
      // 热门视频
      list(value) {
          let params = this.initParams()
          this.$api.courseGetlist(params).then( res => {
              this[value] = res.data.list
          })
      },
      // 会员卡
      card() {
        this.$api.getcoursecard().then(res => {
          if(res.status) {
            this.cardlist = this.cardlist.concat(res.data.list)
          }
        })
      },
      // 购买操作
      buy() {
        this.dialog = true
      },
      // 评论列表
      comment() {
        this.$api.courseGetcoursecomment({...this.commentForm, course_id: this.id}).then(res => {
          if(res.status) {
            this.commentlist = res.data.list
          }
        })
      },
      // 初始化
      init() {
        let data = {
          id: this.id
        }
        if(localStorage.getItem('userToken')) {
          data.token = JSON.parse(localStorage.getItem('userToken')) 
        }
        this.$api.courseGetdetail(data).then(res => {
          if(res.status) {
            this.info = res.data

             // type: "application/x-mpegURL",
                // video/mp4

            if(res.data.video_id) {
              if(res.data.video_id.indexOf('.m3u8') > -1) {
                this.playerOptions.sources[0].type = 'application/x-mpegURL'
              } else {
                this.playerOptions.sources[0].type = 'video/mp4'
              }
            }
                
            this.playerOptions.sources[0].src= res.data.video_id
            this.playerOptions.poster = res.data.cover

            // this.player.options.cover = res.data.cover
            // this.player.options.source = res.data.video_id
            // this.player.options.source = "https://outin-80dc0cdc294111eba5cc00163e1c9256.oss-cn-shanghai.aliyuncs.com/3dc443b3f5e34728bb37c1e7b8c26aea/4d64e043bfd24b9f9f2128d6cfebae9b-748a3d249ac87a316fa0182a6d31a7a4-ld.mp4"
            
            this.cardlist[0].price = res.data.price
            // 价格为0设置为可播放状态
            if(res.data.video_id) {
              this.canPlay = true
            }
          }
        })
      },
      // 获取支付方式
      getPaymentType() {
        this.$api.paymentList().then(res => {
          let data = res.data;
          this.payments = data;
        });
      },
      // 评论操作
      commentAction() {
        const _this = this
        if(this.content.trim().length == 0) {
          this.$message({
            message: "请输入文字",
            type: 'warning'
          })
          return
        }
        this.$api.courseCourseevaluate({
          course_id: this.id,
          content: this.content
        }).then(res =>{
          if(res.status) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
          this.content = ''
          _this.comment()
        })
      },
      
      more() {
        this.sliceNum = 0
      }
    }
}
</script>
<style >

.el-dialog {
  width: 900px;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';

.pay-wrap {
  border: 1px solid #999999;
  padding: 13px 20px;
  margin: 10px 0;
  font-weight: bold;
  height: 200px;
  position: relative;
  .title {
    margin-bottom: 20px;
    color: #333333;
    font-size: 18px;
  }
  .pay-list {
    .pay-type {
      display: inline-block;
      width: 130px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      border: 1px solid $border;
      transition: all 0.2s;
      cursor: pointer;
      padding: 1px;
      box-sizing: border-box;
      &.active,
      &:hover {
        border-color: $theme-color;
      }
    }
    .pay-action {
      position: absolute;
      bottom: 20px;
      right: 20px;
      margin-top: 50px;
      color: #999999;
      font-size: 14px;
      .price {
        color: #EA4B49;
        font-size: 18px;
        margin-right: 20px;
      }
      .el-button {
        background: #EA4B49;
        border: none;
        color: #fff;
      }
    }
  }
}

.brief {
  padding: 10px 0;
  line-height: 24px;
}
.dia-top-pic-wrap {
  width: 100%;
  height: 140px;
  position: relative;
  background: url('~@/assets/images/video/dia-bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  .info {
    display: flex;
    align-items: center;
    .avatar {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .user-name {
      color: #95673A;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .desc {
      color: #95673A;
      font-size: 12px;
    }
  }
  .close-dig{
    position: absolute;
    right: 40px;
    top: 50px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
.dia-wrap {
  padding:  20px;
  
  .card-wrap {
    display: flex;
    .card-item {
      position: relative;
      margin-right: 20px;
      width: 135px;
      height: 180px;
      cursor: pointer;
      .pic {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      div {
        position: relative;
        text-align: center;
        &.title {
          color:#166288;
          font-size: 14px;
          margin: 20px 0;
        }
        &.price {
          margin-top: 10px;
          color: #E7442F;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
}
.video-list {
  &-item {
    display: flex;
    flex-wrap: wrap;
    .link {
      width: 190px;
      color: #595959;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 10px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .title {
        overflow: hidden;
        word-break: break-all;
        word-wrap: break-word;
        height: 28px;
        @include no-wrap-line(2);
      }
      .img-wrap {
        position: relative;
        width: 190px;
        height: 114px;
        margin-bottom: 5px;
        overflow: hidden;
        img {
          width: 190px;
          height: 114px;
          display: block;
          margin: 0 0 12px;
          border-radius: 5px;
        }
      }
      .palynums {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #fff;
        font-size: 12px;
        z-index: 10;
        overflow: hidden;
        height: 20px;
        width: 100%;
        background: rgba(0,0,0,.3);
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          overflow: hidden;
          width: 13px;
          height: 12px;
          margin-right: 3px;
          line-height: 999em;
          vertical-align: -2px;
          margin-left: 8px;
          background: url('http://www.sanlida.cn/Templates/master/sanlida/images/video_pic.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      
    }
  }
}

.tabs {
  position: relative;
  &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #E4E7ED;
      z-index: 1;
  }
  .item {
      // padding: 0 20px;
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      position: relative;
      border-bottom: 2px solid #EA4B49;
      z-index: 2;
      &.active {
          color: #EA4B49;
      }
      &:first-child {
          padding-left: 0;
      }
  }
}
.nav {
  @include line-height(40px);
  font-size: 12px;
  span {
    padding: 0 4px;
    font-size: #757575;
  }
  a:hover {
    color: #000;
  }
}
    .rmtj {
        &-list {
            &-item {
                position: relative;
                width: 100%;
                height: 130px;
                overflow: hidden;
                border-bottom: 1px solid #eee;
                padding: 21px 0;
                &:last-child {
                    border: none;
                }
                .side {
                    bottom: 21px;
                    width: 627px;
                    height: 24px;
                    box-sizing: border-box;
                    float: left;
                    font-size: 14px;
                    line-height: 24px;
                    color: #999;
                    .tag {
                        margin-right: 20px;
                        float: left;
                        span{
                            float: left;
                            margin: 0;
                        }
                    }
                }
                .img-link {
                    position: relative;
                    float: left;
                    width: 190px;
                    height: 127px;
                    overflow: hidden;
                    border-radius: 6px;
                    margin-right: 20px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
                .well {
                        height: 100px;
                        .title {
                            height: 26px;
                            overflow: hidden;
                            font-size: 18px;
                            font-weight: 700;
                            line-height: 26px;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            color: #333;
                        }
                        .des {
                            height: 52px;
                            margin-top: 6px;
                            overflow: hidden;
                            font-size: 16px;
                            line-height: 26px;
                            color: #595959;
                        }
                }
            }
        }
    }
    .tabs {
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #E4E7ED;
            z-index: 1;
        }
        .item {
            // padding: 0 20px;
            height: 40px;
            box-sizing: border-box;
            line-height: 40px;
            display: inline-block;
            list-style: none;
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            position: relative;
            border-bottom: 2px solid #EA4B49;
            z-index: 2;
            &.active {
                color: #EA4B49;
            }
            &:first-child {
                padding-left: 0;
            }
        }
    }
    .article {
        &-left {
            width: 900px;
            float: left;
            margin-bottom: 30px;
            .video-wrap {
              background: #fff;
              padding: 20px;
              border-radius: 6px;
            }
            .other-video {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
            }
            .replay-action {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
              float: left;
              width: 100%;
              box-sizing: border-box;
              .el-textarea {
                margin-bottom: 20px;
              }
              .comment-list-item {
                border: none !important;
              }
            }
            .comment-list {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
              padding-bottom: 80px;
              float: left;
              width: 100%;
              box-sizing: border-box;
              .none-comment {
                font-size: 18px;
                color: #333;
              }
              &-item {
                position: relative;
                margin-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #e6e6e6;
                float: left;
                width: 100%;
                .reply_list_img {
                  float: left;
                  img {
                    width: 50px;
                    height: 50px;
                    display: block;
                    border-radius: 50%;
                  }
                }
                .reply_list_con {
                  width: 780px;
                  float: right;
                  position: relative;
                  // margin-left: 20px;
                  .auth_msg {
                    line-height: 20px;
                    font-size: 12px;
                    color: #8c8c8c;
                    i {
                      margin-right: 5px;
                      font-size: 14px;
                      color: #ff8b3d;
                    }
                  }
                  .reply_txt {
                    overflow: hidden;
                    font-size: 16px;
                    margin-top: 5px;
                  }
                }
              }
            }
            .jxdd {
                width: 100%;
                float: left;
                margin-bottom: 20px;
                .ad {
                    &-item {
                        float: left;
                        width: 264px;
                        margin-right: 20px;
                        border: 1px solid #eee;
                        margin-top: 20px;
                        box-sizing: border-box;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        img {
                            width: 264px;
                            height: 154px;
                        }
                        h3 {
                            height: 39px;
                            overflow: hidden;
                            padding: 10px 15px 15px 15px;
                            .link {
                                width: 100%;
                                height: 39px;
                                float: left;
                                line-height: 22px;
                                overflow: hidden;
                                font-size: 14px;
                                font-weight: normal;
                                
                            }
                        }
                    }
                }
            }

        }
        &-right {
            width: 300px;
            float: right;
            border-radius: 6px;
            font-size: 14px;
            .box {
                width: 260px;
                margin-bottom: 10px;
                padding: 0 20px;
                background: #fff;
                border-radius: 5px;
                h4 {
                    width: 300px;
                    margin-left: -20px;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #e8e8e8;
                    border-radius: 5px 5px 0 0;
                    background: #ffffff;
                    background: linear-gradient(top, #ffffff, #f7f7f7);
                    strong {
                        display: block;
                        width: 122px;
                        margin-left: 15px;
                        color: #434a54;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .link {
                        float: right;
                        margin: -40px 20px 0 0;
                        color: #667ebd;
                        font-size: 12px;
                        
                    }
                }
                &.hot {
                    overflow: hidden;
                    ul {
                        width: 302px;
                        margin-left: -20px;
                        overflow: auto;
                        
                        li {
                            float: left;
                            width: 150px;
                            height: 45px;
                            line-height: 45px;
                            border-bottom: 1px solid #eee;
                            border-right: 1px solid #eee;
                            background: #ffffff;
                            text-align: center;
                            &:hover {
                                color: #EA4B49;
                            }
                            &.more {
                                width: 300px;
                                float: left;
                                height: 45px;
                                line-height: 45px;
                                border-bottom: 1px solid #eee;
                                border-right: 1px solid #eee;
                                background: #ffffff;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
                &.choice{
                    .article {
                        line-height: 24px;
                        margin: 0 0 0 24px;
                        padding: 10px 0;
                        li {
                            padding: 4px 0 5px;
                            em {
                                float: left;
                                width: 14px;
                                height: 14px;
                                line-height: 14px;
                                margin: 3px 0 0 -24px;
                                border: 2px solid #aab2bd;
                                border-radius: 50%;
                                color: #aab2bd;
                                font-family: Tahoma,Verdana,sans-serif;
                                font-size: 10px;
                                text-align: center;
                                &.active {
                                    border: 2px solid #ff6600;
                                    color: #ff6600;
                                }
                            }
                            .link {
                                color: #595959;
                                overflow: hidden;
                               
                            }
                        }
                    }
                }
                &.academy {
                    ul {
                        margin-top: 20px;
                        margin-left: -10px;
                        // overflow: auto;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        li {
                            float: left;
                            width: 125px;
                            height: 145px;
                            line-height: 18px;
                            margin-left: 10px;
                            cursor: pointer;
                            .link {
                                color: #595959;
                                overflow: hidden;
                                position: relative;
                                .palynums {
                                  position: absolute;
                                  top: 66px;
                                  left: 0;
                                  width: 100%;
                                  color: #fff;
                                  font-size: 12px;
                                  z-index: 10;
                                  span {
                                    display: inline-block;
                                    overflow: hidden;
                                    width: 13px;
                                    height: 12px;
                                    margin-right: 3px;
                                    line-height: 999em;
                                    vertical-align: -2px;
                                    margin-left: 8px;
                                    background: url('http://www.sanlida.cn/Templates/master/sanlida/images/video_pic.png') no-repeat;
                                    background-size: 100% 100%;
                                  }
                                }
                                img {
                                  width: 125px;
                                  height: 85px;
                                  display: block;
                                  margin: 0 0 12px;
                                  border-radius: 5px;
                                }
                                .img-bg {
                                  width: 125px;
                                  height: 85px;
                                  display: block;
                                  margin: 0 0 12px;
                                  border-radius: 5px;
                                }
                                .title {
                                  @include no-wrap-line(2)
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .player-wrap {
      width: 100%;
      height: 480px;
      .video-place {
        position: relative;
        width: 100%;
        height: 100%;
        background: #091B26;
        &.white{
          background: #fff;
          .btn-wrap {
            top: 50% !important;
            .btn-item {
              background: #fff !important;
              color: #585858 !important;
              font-size: 18px  !important;
            }
          }
          
        }
        .logo {
          position: absolute;
          top: 20px;
          left: 20px;
        }
        .arrow {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .btn-wrap {
          position: absolute;
          top: 66%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          .btn-item {
            padding: 0 14px;
            cursor: pointer;
            height: 50px;
            border-radius: 4px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            border: none;
            &.btn-01 {
              background: #E7442F;
            }
            // &.btn-02 {
            //   background: #339AD9;
            // }
            // &:first-child {
            //   margin-right: 30px;
            // }
          }
        }
      }
    }

    
</style>

<style >
.dia-pay-wrap .el-dialog {
  border-radius: 24px;
}

.dia-pay-wrap .el-dialog__header {
  display: none !important;
}
.el-radio {
  margin-bottom: 10px;
}
</style>